
import React, { useState } from 'react';
export default function JobReady() {
  return (
    <section className="bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div className="reveal">
          <h2 className="text-2xl md:text-3xl font-bold">Become Job‑Ready</h2>
          <ul className="mt-4 space-y-2 text-slate-700 dark:text-slate-300">
            <li>✓ Build in‑demand AI skills</li>
            <li>✓ Work on real projects & capstones</li>
            <li>✓ Boost interview practice</li>
            <li>✓ Showcase portfolio & get referrals</li>
          </ul>
          <a href="#cta" className="mt-6 inline-block px-5 py-3 rounded-lg bg-brand-600 text-white hoverslate-950 p-6 shadow-soft reveal"></a>
          <div className="grid grid-cols-2 gap-4">
            <div className="stat-card p-4">
              <span className="text-2xl font-bold">4–8</span><div className="text-sm text-slate-600 dark:text-slate-300">months</div>
            </div>
            <div className="stat-card p-4">
              <span className="text-2xl font-bold">6+</span><div className="text-sm text-slate-600 dark:text-slate-300">projects</div>
            </div>
            <div className="stat-card p-4">
              <span className="text-2xl font-bold">1:1</span><div className="text-sm text-slate-600 dark:text-slate-300">mentors</div>
            </div>
            <div className="stat-card p-4">
                     <span className="text-2xl font-bold">100%</span><div className="text-sm text-slate-600 dark:text-slate-300">support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  }
